import { Color, Group } from '@makeswift/runtime/controls';

import { FontFamily } from '~/lib/makeswift/controls/font-tokens';
import { hsl } from '~/lib/makeswift/utils/color';

import { colors } from '../base-colors';

export const slideshow = Group({
  label: 'Slideshow',
  preferredLayout: Group.Layout.Popover,
  props: {
    titleFontFamily: FontFamily({ label: 'Title font', defaultValue: FontFamily.Heading }),
    descriptionFontFamily: FontFamily({ label: 'Description font', defaultValue: FontFamily.Body }),
    numberFontFamily: FontFamily({ label: 'Number font', defaultValue: FontFamily.Accent }),
    title: Color({ label: 'Title', defaultValue: hsl(colors.background.primary.default) }),
    description: Color({ label: 'Description', defaultValue: hsl(colors.background.primary.default, 0.8) }),
    number: Color({ label: 'Number', defaultValue: hsl(colors.background.primary.default) }),
    background: Color({ label: 'Background', defaultValue: hsl(colors.primaryMix.black[75]) }),
    mask: Color({ label: 'Mask', defaultValue: hsl(colors.foreground, 0.8) }),
    pagination: Color({ label: 'Pagination', defaultValue: hsl(colors.background.primary.default) }),
    playBorder: Color({ label: 'Play border', defaultValue: hsl(colors.contrast[300], 0.5) }),
    playBorderHover: Color({
      label: 'Play border hover',
      defaultValue: hsl(colors.contrast[300], 0.8),
    }),
    playText: Color({ label: 'Play text', defaultValue: hsl(colors.background.primary.default) }),
    focus: Color({ label: 'Focus', defaultValue: hsl(colors.primary) }),
  },
});
